module.exports = __webpack_public_path__ + "static/media/bytlogo.d52e73d8.png";